export const PRACTICE_TYPE_OPTIONS = [
  { value: "Many Questions", label: "Many Questions" },
  { value: "Lots of discussion", label: "Lots of discussion" },
  { value: "Heads down reading time", label: "Heads down reading time" },
  { value: "I do, we do, you do", label: "I do, we do, you do" },
  { value: "Other", label: "Other" },
] as const

export type PracticeTypeValue = (typeof PRACTICE_TYPE_OPTIONS)[number]["value"]
